import styled, {css} from 'styled-components';
import {transition} from 'helpers/css';
import {InstanceSelectProps, InstanceSelectVariant} from './types';
import {transparentize} from 'polished';

export const Header = styled.div`
  ${transition()};
  border-radius: 5px;
  border: 1px solid transparent;
  display: flex;
`;

export const Input = styled.input`
  box-sizing: border-box;
  padding: 11px 14px;
  line-height: 20px;
  font-size: 15px;
  width: 100%;
  
  &::placeholder {
    color: ${({theme}) => theme.variables.placeholderColor};
  }
`;

export const AddControl = styled.button`
  ${transition()};
  padding: 0 14px;
  align-items: center;
  display: grid;
  color: ${({theme}) => `
    ${transparentize(.7, theme.variables.color)};
  `};
  
  &:hover {
    color: ${({theme}) => `
      ${transparentize(.4, theme.variables.color)};
    `};
  }
`;

export const Wrapper = styled.div<
  Pick<InstanceSelectProps, 'variant'> & {
    focused: boolean;
  }
>`
  position: relative;
  
  ${({variant, theme}) => {
    switch (variant) {
      case InstanceSelectVariant.Primary: return css`
        background-color: ${theme.variables.accentBackgroundColor};
      `;
      case InstanceSelectVariant.Accent: return css`
        ${Header} {
          background-color: ${theme.variables.backgroundColor};
        }
      `;
    }
  }};

  ${Header} {
    border-color: ${({focused, theme}) => focused && theme.colors.primary};
  }
`;
